import '.m{position:absolute;}.ssr-plugin'
import '.bj{left:0px;}.ssr-plugin'
import '.bk{right:0px;}.ssr-plugin'
import '.z{width:100%;}.ssr-plugin'
import '.bl{height:100%;}.ssr-plugin'
import '.bm{background:linear-gradient(180deg, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.6) 100%);}.ssr-plugin'
import { ImageDivider } from '@app/components/core/imageDivider/ImageDivider'
import { Style, styled } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'
import { PropsWithChildren } from 'react'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'

interface HeroProps extends PropsWithChildren {
  title?: string
  subtitle?: string
  backgroundSrc: string
  fullWidth?: boolean
  centered?: boolean
  style?: Style
}

export const Hero = ({
  backgroundSrc,
  title,
  subtitle,
  fullWidth,
  centered,
  style,
}: HeroProps) => {
  const isMobile = useMediaQuery()

  const content = (
    <>
      {title && (
        <Title.H1
          style={{
            color: fullWidth ? 'var(--shades-white)' : 'var(--primary-blue)',
            margin: 0,
          }}
        >
          {title}
        </Title.H1>
      )}
      {subtitle && (
        <Text.Large
          style={{
            color: fullWidth ? 'var(--shades-white)' : 'var(--primary-blue)',
            margin: 0,
            maxWidth: '50rem',
          }}
        >
          {subtitle}
        </Text.Large>
      )}
    </>
  )

  if (!fullWidth) {
    return (
      <Column
        gap="1.5rem"
        style={{
          alignItems: centered ? 'center' : 'flex-start',
          textAlign: centered ? 'center' : 'left',
          ...style,
        }}
      >
        <ImageDivider
          src={backgroundSrc}
          alt={title}
          fullWidth={false}
          style={{
            height: isMobile ? '14rem' : '41.5rem',
          }}
        />
        {(title || subtitle) && content}
      </Column>
    )
  }

  return (
    <ImageDivider
      src={backgroundSrc}
      alt={title}
      fullWidth
      style={{
        height: isMobile ? '100%' : '41.5rem',
        ...style,
      }}
    >
      {(title || subtitle) && (
        <>
          <div className="m bj bk z bl bm"
          />
          <Column
            gap="1rem"
            style={{
              justifyContent: 'flex-end',
              alignItems: centered ? 'center' : 'flex-start',
              textAlign: centered ? 'center' : 'left',
              height: '100%',
              position: 'relative',
              margin: isMobile ? '1rem 0' : '0 0 6.25rem 0',
            }}
          >
            {content}
          </Column>
        </>
      )}
    </ImageDivider>
  )
}
